import { z } from "zod";

export const validationSchema = z.object({
  teamId: z.string().uuid(),
  userIds: z.array(z.string().uuid()),
});
